import { Request } from 'commons/utils/request'
import { AnnualReviewEditMode } from '~bank-annual-review/types/Manage'

export const getAnnualReviewEditMode = (id: number) =>
  Request.post<AnnualReviewEditMode, { id: number }>(Request.urls.bank.annualReviewEditMode, { id })
